import { useContext, JSX, useEffect, useState } from 'react';
import { Button, Typography, AppHeader, Icon, IconButton } from '@ace-clublabs/shared-component-library';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';
import { LoadingIndicator } from '../components/LoadingIndicator';
import { useHistory } from 'react-router-dom';
import { FlowType, MembershipLevel } from '@ace-clublabs/common-membership-api-types';
import { SELECTED_MEMBERSHIP_LEVEL_URL_QUERY_PARAM } from '../shared/types';
import { benefitsHelper } from '../utils/benefitsHelper';

export const AdditionalBenefitsPage: () => JSX.Element = () => {
  const { loadingInfo, sessionData, membershipInfo, refreshSession } = useContext(MembershipAppStateContext);
  const history = useHistory();
  const currentUrl = window.location.href;
  const urlSearchParams = new URL(currentUrl).searchParams;
  const urlSelectedLevel = urlSearchParams.get(SELECTED_MEMBERSHIP_LEVEL_URL_QUERY_PARAM) as MembershipLevel;
  const [membershipLevel] = useState(urlSelectedLevel || MembershipLevel.CLASSIC);
  const additionalBenefitsTitle = membershipLevel?.toLowerCase()?.replace(/(^|\s)\S/g, (match) => match.toUpperCase());
  const isMajorRocket = sessionData.flowType === FlowType.MAJOR_ROCKET;

  const benefits = benefitsHelper.getBenefitsByMembershipLevel(sessionData, membershipLevel);

  useEffect(() => {
    refreshSession();
  }, []);

  useEffect(() => {
    if (urlSelectedLevel === membershipLevel) {
      urlSearchParams.delete(SELECTED_MEMBERSHIP_LEVEL_URL_QUERY_PARAM);
      const newUrl = currentUrl.split('?')[0];
      window.history.replaceState(null, '', newUrl);
    }
  }, [membershipLevel]);

  // return loadingInfo.isLoading || membershipInfo?.benefits == null ? (
  return loadingInfo.isLoading ? (
    <div>
      <AppHeader sx={{ padding: 0 }} />
      <LoadingIndicator loadingInfo={loadingInfo} maxSteps={0} currentStep={loadingInfo.loadingDetails.length} />
    </div>
  ) : (
    <>
      <div className="additional-benefit-page-view">
        <div className="additional-benefit-header">
          <AppHeader alignItems="center" sx={{ padding: 0 }} />
          <IconButton
            aria-label="close add associate page"
            className="close-icon"
            onClick={() => {
              history.goBack();
            }}
            sx={{
              position: 'absolute',
              top: '30px',
              right: '80px',
              '@media (max-width: 600px)': {
                top: '20px',
                right: '45px',
              },
            }}
          >
            <Icon iconName="xmark-regular" color="htmlColor" htmlColor="black" />
          </IconButton>
        </div>
        <div className="additional-benefit-details">
          <div className="additional-benefit-title">
            <Typography variant="h5" className="card-title">
              {additionalBenefitsTitle}
            </Typography>
          </div>
          <div className="additional-benefit-subsection">
            <div className="additional-benefit-subtitle">
              <Icon iconName="truck-duotone" color="primary" sx={{ fontSize: '1.6rem' }} />
              <Typography variant="b1Bold" className="group-1-title">
                {benefits?.group1?.title}
              </Typography>
            </div>
            <div className="additional-benefit-list-container">
              {benefits?.group1?.benefits?.map((benefit: any, i: any) => (
                <>
                  <div className="additional-benefit-list-item">
                    <Icon
                      iconName="check-regular"
                      sx={{ fontSize: '1rem', color: '#7527B9', marginTop: '4px', alignSelf: 'start' }}
                    ></Icon>
                    <Typography variant="b2Regular" className="benefit-description">
                      {benefit}
                    </Typography>
                  </div>
                </>
              ))}
            </div>
          </div>
          <div className="additional-benefit-subsection">
            <div className="additional-benefit-subtitle">
              <Icon iconName="badge-percent-duotone" color="primary" sx={{ fontSize: '1.5rem' }} />
              <Typography variant="b1Bold" className="group-2-title">
                {benefits?.group2?.title}
              </Typography>
            </div>
            <div className="additional-benefit-list-container">
              {benefits?.group2?.benefits?.map((benefit: any, i: any) => (
                <>
                  <div className="additional-benefit-list-item">
                    <Icon
                      iconName="check-regular"
                      sx={{ fontSize: '1rem', color: '#7527B9', marginTop: '4px', alignSelf: 'start' }}
                    ></Icon>
                    <Typography variant="b2Regular" className="benefit-description">
                      {benefit}
                    </Typography>
                  </div>
                </>
              ))}
            </div>
          </div>
          <div className="additional-benefit-subsection">
            <div className="additional-benefit-subtitle">
              <Icon iconName="id-card-duotone" color="primary" sx={{ fontSize: '1.6rem' }} />
              <Typography variant="b1Bold" className="group-3-title">
                {benefits?.group3?.title}
              </Typography>
            </div>
            <div className="additional-benefit-list-container">
              {benefits?.group3?.benefits?.map((benefit: any, i: any) => (
                <>
                  <div className="additional-benefit-list-item">
                    <Icon
                      iconName="check-regular"
                      sx={{ fontSize: '1rem', color: '#7527B9', marginTop: '4px', alignSelf: 'start' }}
                    ></Icon>
                    <Typography variant="b2Regular" className="benefit-description">
                      {benefit}
                    </Typography>
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>
        {isMajorRocket ? (
          <></>
        ) : (
          <Button
            label="View all benefits"
            fullWidth
            onClick={() => {
              window.open('https://www.ace.aaa.com/membership/benefit-chart.html', '_blank');
            }}
            variant="text"
            size="medium"
            id="moreBenefitsButton"
            sx={{ marginTop: '1rem' }}
          ></Button>
        )}
      </div>
    </>
  );
};
